import React from 'react';
import PropTypes from 'prop-types';
import ButtonSecondary from './ButtonSecondary';
import SelectMenu from './SelectMenu';
import { rangeRight } from 'lodash';
import './DatePickerHeader.scss';
var extraYearBuffer = 5;
var lastMonthIndex = 11;
var startYear = 1950;
// A component consumed by react-deatepicker's custom header render function.
// For this reason, we use an actual date object instead of a ISO 8601 date string.
var DatePickerHeader = function (_a) {
    var changeYear = _a.changeYear, date = _a.date, onDecreaseMonth = _a.onDecreaseMonth, onDecreaseYear = _a.onDecreaseYear, onIncreaseMonth = _a.onIncreaseMonth, onIncreaseYear = _a.onIncreaseYear, shouldShowOnlyYear = _a.shouldShowOnlyYear;
    var selectedYear = date.toLocaleString('default', { year: 'numeric' });
    var endYear = new Date().getFullYear() + extraYearBuffer;
    var years = rangeRight(startYear, endYear + 1);
    // To disable the button when we are in the last month of the endYear.
    var endDateLimit = new Date(endYear, lastMonthIndex);
    return (React.createElement("div", { className: 'DatePickerHeader' },
        React.createElement(ButtonSecondary, { icon: 'arrowLeft', isDisabled: Number(selectedYear) === startYear, onClick: shouldShowOnlyYear ? onDecreaseYear : onDecreaseMonth, size: 'small' }),
        shouldShowOnlyYear ? (React.createElement(SelectMenu, { onChange: changeYear, shouldShowSearch: false, value: parseInt(selectedYear) }, years.map(function (year) { return (React.createElement(SelectMenu.Item, { key: year, value: year }, year)); }))) : (React.createElement(React.Fragment, null,
            React.createElement("h4", { className: 'DatePickerHeader__title' }, date.toLocaleString('default', { month: 'long' })),
            React.createElement(SelectMenu, { onChange: changeYear, shouldShowSearch: false, value: parseInt(selectedYear) }, years.map(function (year) { return (React.createElement(SelectMenu.Item, { key: year, value: year }, year)); })))),
        React.createElement(ButtonSecondary, { icon: 'arrowRight', isDisabled: shouldShowOnlyYear
                ? Number(selectedYear) === endYear
                : date >= endDateLimit, onClick: shouldShowOnlyYear ? onIncreaseYear : onIncreaseMonth, size: 'small' })));
};
DatePickerHeader.defaultProps = {
    shouldShowOnlyYear: false
};
DatePickerHeader.propTypes = {
    changeYear: PropTypes.func,
    date: PropTypes.instanceOf(Date).isRequired,
    onDecreaseMonth: PropTypes.func.isRequired,
    onDecreaseYear: PropTypes.func,
    onIncreaseMonth: PropTypes.func.isRequired,
    onIncreaseYear: PropTypes.func,
    shouldShowOnlyYear: PropTypes.bool
};
export default DatePickerHeader;
//# sourceMappingURL=DatePickerHeader.js.map